<script setup>
import { levelEnum } from "@/utilities/enum";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          List User Internal
        </h2>
        <p class="text-gray-500">
          Sini-Saja membantu mengelola & memantau perkembangan kegiatan
          kontraktor
        </p>
        <v-row class="mt-2 mb-4">
          <div class="flex justify-end w-full mb-4">
            <v-btn
              prepend-icon="mdi-account"
              class="bg-red-600 text-white capitalize"
              data-bs-toggle="modal"
              data-bs-target="#TambahUser"
            >
              Tambah User Internal
            </v-btn>
          </div>
          <div class="mt-4 rounded-lg shadow-md w-full">
            <v-data-table-server
              v-model:items-per-page="dataTable.pagination.itemsPerPage"
              :items-per-page-options="[5, 10, 25, 50, 100]"
              :headers="dataTable.headers"
              :items="dataTable.items"
              :items-length="dataTable.pagination.totalItems"
              @update:options="fetchData"
            >
              <template v-slot:item="{ item, index }">
                <tr
                  class="border-b border-gray-950 h-16"
                  :class="{ 'bg-gray-50': index % 2 !== 0 }"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.username ? item.username : "-" }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.isafeNo }}</td>
                  <td>{{ item.department }}</td>
                  <td>{{ item.role.toString() }}</td>
                  <td>
                    <div class="gap-3">
                      <button
                        class="btn btn-outline-danger btn-sm"
                        @click="
                          DeleteItemUser(
                            item.id,
                            item.kontraktorId,
                            item.email,
                            item.username
                          )
                        "
                      >
                        <font-awesome-icon :icon="['fas', 'trash']" />
                      </button>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!--  Tambah User Internal -->
  <div
    class="modal fade rounded-top-5"
    id="TambahUser"
    tabindex="-1"
    aria-labelledby="TambahUser"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Tambah User Internal</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-3">
            <form @submit.prevent="onFormSubmit">
              <div class="form-group">
                <label for="email" class="form-label fs-8"
                  ><small>Email</small></label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="email"
                  v-model="FormValues.email"
                  autofocus
                  @input="validateEmail"
                  :class="{
                    'is-invalid': !isEmailValid,
                    'is-valid': isEmailValid && emailCek,
                  }"
                  :disabled="isUsernameReceived"
                />
                <small
                  class="text-danger font-italic"
                  style="font-size: 10px; font-style: italic"
                  v-if="!isEmailValid && emailCek"
                  >Email invalid</small
                >
              </div>
              <div class="form-group mt-3">
                <label for="username" class="form-label fs-8"
                  ><small>iSafe No</small></label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="username"
                  v-model="FormValues.username"
                  :disabled="isUsernameReceived"
                  required
                />
              </div>
              <div class="form-group">
                <label for="username" class="form-label fs-8"
                  ><small>Nama</small></label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="isafe_no"
                  v-model="FormValues.isafe_no"
                  :disabled="isUsernameReceived"
                  required
                />
              </div>
              <div class="form-group">
                <label for="username" class="form-label fs-8"
                  ><small>Departemen</small></label
                >
                <input
                  type="text"
                  class="form-control fs-9"
                  id="department"
                  v-model="FormValues.department"
                  :disabled="isUsernameReceived"
                  required
                />
              </div>
              <div class="form-group mb-5" v-if="isUsernameReceived">
                <label for="username" class="form-label fs-8"
                  ><small>Level</small></label
                >
                <select class="form-select fs-9" v-model="FormValues.roles">
                  <option selected disabled>Pilih Role</option>
                  <option :value="levelEnum.ADMIN">Admin</option>
                  <option :value="levelEnum.OHS">OHS</option>
                  <option :value="levelEnum.ENVIRONMENT">Environment</option>
                  <option :value="levelEnum.IMPROVEMENT">Continuous Improvement</option>
                </select>
              </div>
              <div class="d-flex justify-content-center mt-3 mb-1">
                <button
                  type="button"
                  @click="CheckUserByEmail"
                  class="btn btn-sm bg-primary w-100 text-white d-block"
                >
                  Cek Email
                </button>
              </div>
              <div
                class="d-flex justify-content-center mt-1"
                v-if="FormValues.roles"
              >
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-100 text-white"
                  :disabled="!isUsernameReceived"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  End Tambah User Internal -->

  <!-- Update User Internal -->
  <div
    class="modal fade rounded-top-5"
    tabindex="-1"
    id="EditUser"
    aria-labelledby="EditUser"
    aria-hidden="true"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog-centered rounded-top-5">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
        style="min-height: 156px; min-width: 350px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-4 border-0"
          style="
            min-height: 100px;
            min-width: 350px;
            background: rgba(181, 26, 26, 1);
          "
        >
          <div class="d-flex justify-content-end w-100 p-2">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="p-3 text-white text-center mb-3"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Edit User Kontraktor</h4>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-3">
            <form @submit.prevent="UpdateUserInternal">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control fs-9"
                  id="id"
                  v-model="FormValuesEdit.userId"
                  hidden="hidden"
                />
                <label for="email" class="form-label fs-8"
                  ><small>Email</small></label
                >
                <input
                  type="email"
                  class="form-control fs-9"
                  id="email"
                  v-model="FormValuesEdit.email"
                />
              </div>
              <div class="form-group mt-3 mb-5">
                <label for="email" class="form-label fs-8"
                  ><small>Nama Kontraktor</small></label
                >
                <select
                  class="form-select form-select-sm"
                  v-model="FormValuesEdit.kontraktorId"
                >
                  <option value="" disabled selected>
                    Silakan Pilih Kontraktor
                  </option>
                  <option
                    v-for="(item, index) in Kontraktor"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.namaKontraktor }}
                  </option>
                </select>
              </div>

              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-sm bg-danger w-75 text-white"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Update User Internal -->
</template>

<script>
import axios from "axios";
import {
  API_BASE_URL,
  CMS_CHECK_USER_EMAIL,
  CMS_GET_INTERNAL_KONTRAKTOR,
  CMS_GET_USER_LIST,
  CMS_GET_USER_UPDATE,
  CMS_USER_REGISTER,
} from "@/constants";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment from "moment";
import GlobalDataMixin from "@/GlobalDataMixin";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";

export default {
  name: "MUserListInternalPage",
  mixins: [GlobalDataMixin],
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "No.", align: "start", sortable: false, width: "50px" },
        { title: "iSafe No", align: "start", sortable: false, width: "100px" },
        { title: "Email", align: "start", sortable: false, width: "300px" },
        { title: "Nama", align: "start", sortable: false },
        { title: "Departemen", align: "start", sortable: false },
        { title: "Role", align: "start", sortable: false },
        { title: "Aksi", align: "start", sortable: false, width: "75px" },
      ]),
      Users: [],
      Kontraktor: [],
      internalUser: [],
      currentPage: 1,
      perPage: 100,
      totalData: 0,
      filtersInitialized: false,
      FormValues: {
        keyword: "",
        perPage: 5,
        userId: "",
        email: "",
        kontraktorId: "",
        NamaKontraktor: "",
        username: "",
        status: [1],
        isafe_no: "",
        department: "",
        roles: null,
      },
      FormValuesEdit: {
        userId: "",
        email: "",
        isafe_no: "",
        kontraktorId: "",
        NamaKontraktor: "",
        status: [1],
      },
      isModalVisible: false,
      modalTitle: "",
      modalContent: "",
      isUsernameReceived: false,
      isEmailValid: true,
      emailCek: false,
      roleOptions: [
        { value: "ADMIN", label: "ADMIN" },
        { value: "OHS", label: "OHS" },
      ],
    };
  },
  created() {
    this.initFiltersFromQuery();
  },
  mounted() {
    this.initFiltersFromQuery();
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.fetchData();
    }
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      if (q.page) {
        this.currentPage = parseInt(q.page) || 1;
        this.dataTable.pagination.page = this.currentPage;
      }
      if (q.perPage) {
        this.FormValues.perPage = parseInt(q.perPage) || 5;
        this.dataTable.pagination.itemsPerPage = this.FormValues.perPage;
      }
    },
    syncFiltersToUrl() {
      const query = {};
      if (this.currentPage && this.currentPage !== 1) {
        query.page = this.currentPage;
      }
      if (this.FormValues.perPage && this.FormValues.perPage !== 5) {
        query.perPage = this.FormValues.perPage;
      }
      this.$router.replace({ query }).catch(() => {});
    },
    buildUserQuery() {
      const query = {};
      if (this.currentPage && this.currentPage !== 1) {
        query.page = this.currentPage;
      }
      if (this.FormValues.perPage && this.FormValues.perPage !== 5) {
        query.perPage = this.FormValues.perPage;
      }
      return query;
    },
    closeModal() {
      this.FormValues.email = "";
      this.FormValues.username = "";
      this.FormValues.department = "";
      this.FormValues.isafe_no = "";
      this.FormValues.roles = null;
      this.isUsernameReceived = false;
      this.isEmailValid = true;
      this.emailCek = false;
    },
    validateEmail() {
      const re = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      this.isEmailValid = re.test(this.FormValues.email);
      this.emailCek = true;
    },
    openModal(kontraktorId, email, userId) {
      this.isModalVisible = true;
      this.FormValuesEdit.email = email;
      this.FormValuesEdit.kontraktorId = kontraktorId;
      this.FormValuesEdit.userId = userId;
    },
    getKontraktorNameById(id) {
      const kontraktor = this.Kontraktor.find((item) => item.id === id);
      return kontraktor ? kontraktor.namaKontraktor : "-";
    },
    getAlamatKontraktorById(id) {
      const kontraktor = this.Kontraktor.find((item) => item.id === id);
      return kontraktor ? kontraktor.alamat : "-";
    },
    FetchKontraktor() {
      let bodyJSONKontraktor = {
        // kontraktorId: this.FormValues.kontraktorId,
        // NamaKontraktor: this.FormValues.NamaKontraktor,
        header: {
          page: 1,
          perPage: 100,
          usecase: "isafe",
        },
      };
      axios
        .post(API_BASE_URL + CMS_GET_INTERNAL_KONTRAKTOR, bodyJSONKontraktor)
        .then((res) => {
          this.Kontraktor = res.data.data;
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan!",
          });
        });
    },
    fetchData({ page, itemsPerPage } = {}) {
      if (page) {
        this.currentPage = page;
      }
      if (itemsPerPage) {
        this.FormValues.perPage = itemsPerPage;
      }
      this.syncFiltersToUrl();
      let bodyJson = {
        header: {
          page: this.currentPage,
          perPage: this.FormValues.perPage,
          // usecase: "bebas",
        },
        status: [1],
        usecase: "isafe",
      };
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      axios
        .post(API_BASE_URL + CMS_GET_USER_LIST, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: `Bearer ${tokens.token}`,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then((res) => {
          let result = {};
          result.data = res.data.users;
          result.total_data = res.data.totalData;
          result.total_per_page = this.FormValues.perPage;
          result.current_page = this.currentPage;

          this.dataTable = SetDataTableResponse(this.dataTable, result);

          this.Users = res.data.users;
          this.internalUser = res.data.users;
          // this.totalData = this.Users.filter((item) => item.username !== null).length;
          // this.internalUser = this.Users.filter((item) => item.username !== null);
          this.totalData = res.data.totalData;
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan!",
          });
        });
    },
    onFormSubmit() {
      if (this.isEmailValid) {
        this.RegisterUser();
      }
    },

    CheckUserByEmail() {
      this.validateEmail();
      if (this.isEmailValid) {
        let bodyJSONCreate = {
          email: this.FormValues.email,
        };

        axios
          .get(API_BASE_URL + CMS_CHECK_USER_EMAIL, {
            params: bodyJSONCreate,
            headers: {
              role: "isafe",
              Authorization: `Bearer ${this.userData.token}`,
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
              "Access-Control-Allow-Headers":
                "Content-Type, Authorization, Accept",
            },
          })
          .then((response) => {
            this.isUsernameReceived = response.data.isafe_no;
            if (this.isUsernameReceived && response.data.isafe_no) {
              this.FormValues.username = response.data.isafe_no;
              this.FormValues.isafe_no = response.data.name;
              this.FormValues.department = response.data.department;
            } else {
              Swal.fire({
                icon: "error",
                title: "Oppsss....!!!.",
                text: response.data.name
                  ? "Isafe Number tidak ditemukan (" +
                    response.data.isafe_no +
                    ")"
                  : "Isafe Number tidak ditemukan.",
              });
            }
          })
          .catch((error) => {
            this.isEmailValid = false;
            this.isUsernameReceived = true;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                "Terjadi kesalahan (" +
                error.response.data.status.message +
                ")",
            });
          });
      }
    },

    RegisterUser() {
      if (this.isEmailValid) {
        let bodyJSONCreate = {
          email: this.FormValues.email,
          name: this.FormValues.username,
          header: {
            usecase: "isafe",
          },
          isafeno: this.FormValues.isafe_no,
          department: this.FormValues.department,
          roles: [this.FormValues.roles], //admin, ktt, ohs, kustodian -> kecil semua, bisa multiple
        };

        axios
          .post(API_BASE_URL + CMS_USER_REGISTER, bodyJSONCreate, {
            headers: {
              role: "isafe",
              Authorization: `Bearer ${this.userData.token}`,
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
              "Access-Control-Allow-Headers":
                "Content-Type, Authorization, Accept",
            },
          })
          .then(() => {
            this.FormValues = {
              email: "",
              username: "",
              isafe_no: "",
              department: "",
              roles: null,
            };
            setTimeout(() => {
              location.reload();
            }, 1000);
            Swal.fire({
              icon: "success",
              title: "User internal berhasil disimpan!",
              showConfirmButton: true,
            });
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                "Terjadi kesalahan saat menyimpan user! (" +
                err.response.data.message +
                ")",
            });
          });
      }
    },

    UpdateUserInternal() {
      const currentDate = new Date(moment().format("YYYY-MM-DD HH:mm:ss"));
      let bodyJSONCreate = {
        userId: this.FormValuesEdit.userId,
        email: this.FormValuesEdit.email,
        kontraktorId: this.FormValuesEdit.kontraktorId,
        status: 1,
        updated_at: currentDate,
        created_at: currentDate,
      };
      const user = localStorage.getItem("user_cms");
      const tokens = JSON.parse(user);
      axios
        .put(API_BASE_URL + CMS_GET_USER_UPDATE, bodyJSONCreate, {
          headers: {
            role: "isafe",
            Authorization: `Bearer ${tokens.token}`,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then(() => {
          this.FormValuesEdit = {
            email: "",
            kontraktorId: "",
          };
          setTimeout(() => {
            location.reload();
          }, 1500);
          Swal.fire({
            icon: "success",
            title: "User berhasil diupdate!",
            showConfirmButton: true,
            timer: 1000,
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Terjadi kesalahan saat menyimpan user!",
          });
        });
    },

    DeleteItemUser(userId, kontraktorId, email, username) {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin ingin menghapus user ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Hapus!",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          const user = localStorage.getItem("user_cms");
          const tokens = JSON.parse(user);
          const currentDate = new Date(moment().format("YYYY-MM-DD HH:mm:ss"));
          let bodyJSONCreate = {
            userId: userId,
            kontraktorId: kontraktorId,
            email: email,
            username: username,
            updated_at: currentDate,
            created_at: currentDate,
            status: 0,
          };

          axios
            .put(API_BASE_URL + CMS_GET_USER_UPDATE, bodyJSONCreate, {
              headers: {
                role: "isafe",
                Authorization: `Bearer ${tokens.token}`,
                Accept: "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                "Access-Control-Allow-Headers":
                  "Content-Type, Authorization, Accept",
              },
            })
            .then(() => {
              this.Users = this.Users.filter((item) => item.userId !== userId);
              Swal.fire({
                icon: "success",
                title: "User Admin berhasil dihapus!",
                showConfirmButton: true,
                timer: 1000,
              });
              setTimeout(() => {
                location.reload();
              }, 1000);
            })
            .catch(() => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Terjadi kesalahan saat menghapus user admin!",
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}
:deep(thead) {
  background-color: #fecaca;
}
/* :deep(.v-data-table-footer) {
  background-color: #fecaca;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: hidden;
} */
</style>
